import React, { useContext } from "react";

import { Box, Typography } from "@mui/material";
import { observer } from "mobx-react-lite";
import { makeStyles } from "tss-react/mui";

import CalorieFireIcon from "@components/Icons/CalorieFireIcon";

import MealPlanFormStore from "../store/MealPlanFormStore";

const useStyles = makeStyles()((theme) => ({
  root: {
    marginBottom: theme.spacing(2),
    border: "1px solid #EDF0F5",
    display: "flex",
  },
  icon: {
    fontSize: 64,
  },
  bold: {
    fontWeight: "bold",
  },
}));

const RecommendedCalories: React.FC = observer(() => {
  const { classes } = useStyles();

  const store = useContext(MealPlanFormStore.Context);

  return (
    <Box
      display="flex"
      alignItems="center"
      paddingY={8}
      paddingX={2}
      width="50%"
    >
      <CalorieFireIcon className={classes.icon} />
      <Box marginLeft={5} width="514px">
        <Typography color="textSecondary">
          Coach recommendation calories
        </Typography>
        <Typography variant="h4" className={classes.bold}>
          {Math.round(store.recommendedCaloriesKcal)} kcal
        </Typography>
      </Box>
    </Box>
  );
});

export default RecommendedCalories;
